import { render, staticRenderFns } from "./MatchItem.vue?vue&type=template&id=cd16b582&"
import script from "./MatchItem.vue?vue&type=script&lang=js&"
export * from "./MatchItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd16b582')) {
      api.createRecord('cd16b582', component.options)
    } else {
      api.reload('cd16b582', component.options)
    }
    module.hot.accept("./MatchItem.vue?vue&type=template&id=cd16b582&", function () {
      api.rerender('cd16b582', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/financial/reconciliation/santander/pix/components/MatchItem.vue"
export default component.exports